import { render, staticRenderFns } from "./password-forgot.vue?vue&type=template&id=e8417ef0&scoped=true&"
import script from "./password-forgot.vue?vue&type=script&lang=js&"
export * from "./password-forgot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8417ef0",
  null
  
)

export default component.exports